
import { Card, BlockStack, Avatar, Layout, Link, ResourceList, Text, InlineStack, EmptyState } from "@shopify/polaris";
import { getBestAvatar, timeAgo } from "../utils";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import { useNavigate } from "react-router-dom";

export default function MessagesLog({ messages, allMessages, loading, setCreatorOpen }) {
  const { leads, setInitialCreatorEmail } = usePartnerUp()
  const navigate = useNavigate();

  return (
    <Layout>
      <Layout.Section>
        <Card padding="0">
          <ResourceList
            loading={loading}
            resourceName={{ singular: 'message', plural: 'messages' }}
            emptyState={
              <Card>
                <EmptyState heading="None Yet" />
              </Card>
            }
            items={messages || []}
            renderItem={(item) => {
              const { id, timestamp, message, creatorID } = item;
              console.log('timestamp', timestamp)
              const creator = leads.find(lead => creatorID === lead.id) || {}
              return (
                <ResourceList.Item
                  id={id}
                  onClick={() => {
                    if (message?.toLowerCase()?.includes('email')
                      || message?.toLowerCase()?.includes('step')
                      || message?.toLowerCase()?.includes('opened')
                      || message?.toLowerCase()?.includes('sequence')
                      || message?.toLowerCase()?.includes('clicked')
                    ) {
                      navigate('/emails?creatorID=' + creatorID)
                    } else {
                      navigate(`/leads/?id=${creator?.id}`)
                    }
                  }}
                  media={
                    null
                    // getEventIcon(message)
                  }
                >
                  <BlockStack gap="100">
                    <BlockStack gap="100">
                      <InlineStack gap="100" align="start">
                        <div>{message}</div>
                      </InlineStack>
                    </BlockStack>
                    <InlineStack gap="100" align="start" blockAlign="center">
                      {
                        allMessages ? (
                          <InlineStack align="start" gap="100" blockAlign="center">
                            <Avatar shape="square" source={getBestAvatar(creator)} size="sm" />
                            <Link removeUnderline>{creator?.name}</Link>
                          </InlineStack>
                        ) : (
                          null
                        )
                      }
                      <Text variant="bodySm" color="subdued">{timeAgo(timestamp)}</Text>
                    </InlineStack>
                  </BlockStack>
                </ResourceList.Item>
              )
            }}
          />
        </Card>
      </Layout.Section>
    </Layout>
  )
}
